import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Btns,
  ButtonL,
  Content,
  ImgWrap,
  Section,
  TextDiv,
} from "../../styles/Common";
import { styled } from "styled-components";
import { getToken, returnLoginStatus } from "../hooks/authFunc";
import TopPointBanner from "../main/TopPointBanner";
import { useDispatch, useSelector } from "react-redux";
import { inputPriceFormat, replaceCommas, unComma } from "../hooks/basicFunc";
import axios from "axios";
import { amoActions } from "../../store/slices/amoSlice";
import useDidMountEffect from "../hooks/useDidMountEffect";
import { Modal } from "../modal/Modal";
import { Loading } from "../modal/Loading";

let intervalTarget;
const ToAmoComponent = () => {
  const navigate = useNavigate();
  const isLogin = returnLoginStatus();
  const dispatch = useDispatch();
  const accessToken = getToken();
  const swapInfo = useSelector((state) => state.amo.swapInfo);
  const modalMsg = useSelector((state) => state.amo.modalMsg);
  const swapMupToAmoSuccess = useSelector(
    (state) => state.amo.swapMupToAmoSuccess
  );
  const swapMupToAmoPending = useSelector(
    (state) => state.amo.swapMupToAmoPending
  );
  const swapMupToAmoResultCode = useSelector(
    (state) => state.amo.swapMupToAmoResultCode
  );
  const [openModal, setOpenModal] = useState(false);
  const [openLoading, setOpenLoading] = useState(false);
  const [point, setPoint] = useState("");
  const [editPoint, setEditPoint] = useState(0);
  const [amoPrice, setAmoPrice] = useState(0);
  const getData = () => {
    const params = {};
    dispatch(amoActions.fetchSwapInfo({ params, accessToken }));
  };
  const getAmoPrice = async () => {
    const apiUrl = "https://api.bithumb.com/public/ticker/AMO";

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;

      // API 응답에서 AMO 가격 추출
      const price = data.data.closing_price;

      setAmoPrice(price);
    } catch (error) {
      console.error(`에러 발생: ${error}`);
      return null;
    }
  };

  const startInterval = () => {
    intervalTarget = setInterval(getAmoPrice, 60000);
  };

  const stopInterval = () => {
    clearInterval(intervalTarget);
  };
  useEffect(() => {
    getData();
    getAmoPrice();
    startInterval();
    return () => {
      stopInterval();
    };
    //todo
    //교환될 amo 코인  = (입력한 뮤포인트*1krw - 고객수수료) / 아모코인시세
    // ex) 1mup == 1krw  이니까 100mup 입력시 수수료(10) 빼고 / 아모코인시세
  }, []);

  const checkingValue = () => {
    // 최소 입력값과 단위 설정
    const minValue = swapInfo.info.mupMin;
    const maxValue = swapInfo.info.mupMax;
    const unit = swapInfo.info.mupUnit;
    const myMup = swapInfo.info.mup;
    const mup2amoSwapCount = swapInfo.info.mup2amoSwapCount;
    const mup2amoAvailable = swapInfo.info.mup2amoAvailable;

    // 입력값이 숫자인지 확인
    if (!isNaN(point)) {
      const numericValue = parseFloat(point);

      if (numericValue < minValue) {
        // console.log("최소값 이상 입력");
        dispatch(
          amoActions.showMsg({
            msg: `${minValue} MUP 이상 교환 가능합니다`,
            type: "",
          })
        );
      } else if (mup2amoAvailable == 0) {
        // console.log("일 횟수 초과");
        dispatch(
          amoActions.showMsg({
            msg: `일 가능횟수를 초과하였습니다.(일 스왑가능횟수 : ${mup2amoSwapCount})`,
            type: "",
          })
        );
      } else if (numericValue > maxValue) {
        // console.log("일한도 초과");
        dispatch(
          amoActions.showMsg({
            msg: `일한도를 초과하였습니다.`,
            type: "",
          })
        );
      } else if (numericValue > myMup) {
        // console.log("뮤포인트 이하 가능");
        dispatch(
          amoActions.showMsg({
            msg: `${myMup} MUP 이하 교환 가능합니다`,
            type: "",
          })
        );
      } else if (!(numericValue % unit === 0)) {
        // console.log("100단위로만 입력 가능");
        dispatch(
          amoActions.showMsg({
            msg: `${unit} 단위로만 교환 가능합니다`,
            type: "",
          })
        );
      } else {
        const params = {
          mup: unComma(point),
        };
        console.log(params);
        dispatch(
          amoActions.fetchSwapMupToAmo({
            params,
            accessToken,
          })
        );
      }
    } else {
      // 숫자가 아닌 경우에 대한 처리를 추가할 수 있습니다.
      const onlyNumbers = point.replace(/\D/g, "");
      setPoint(onlyNumbers);
    }
  };

  const getMaxValue = (inputValue) => {
    // 입력값에서 숫자만 추출
    if (!inputValue) return;
    const numericValue = inputValue.toString().replace(/\D/g, "");

    // 입력값을 100으로 나눈 몫 구하기
    const quotient = Math.floor(numericValue / swapInfo.info.mupUnit);

    // 최대값 계산
    const maxValue = quotient * swapInfo.info.mupUnit;

    return maxValue;
  };

  const getExchangeValue = (inputValue) => {
    // console.log(swapInfo.info, amoPrice);
    const { mup, mup2amoFee, mup2amoVat, mup2amoVatOpt } = swapInfo.info;

    let userFee = 0;
    let userVat = 0;
    let userCharge = 0;
    let mup2amo;
    if (!inputValue) {
      mup2amo = "";
    } else {
      if (mup2amoFee > 0) {
        const _userFee = inputValue * (mup2amoFee / 100); //수수료
        userFee = Math.floor(_userFee);
        const _userVat = _userFee * 0.1; //vat (_userFee * (mup2amoVat / 100)이지만 고정이라서 그냥 0.1로 사용;)
        const uVatOpt = mup2amoVatOpt ? 1 : 0;
        userVat = Math.round(_userVat) * uVatOpt;
        userCharge = Math.round(userFee + userVat);
        mup2amo = (inputValue - userCharge) / amoPrice;

        mup2amo = Number(mup2amo.toFixed(4));
      } else {
        //고객수수료 없을 경우
        mup2amo = inputValue / amoPrice;
        mup2amo = Number(mup2amo.toFixed(4));
      }
    }
    return mup2amo;
  };

  useDidMountEffect(() => {
    if (modalMsg.msg) {
      setOpenModal(true);
    }
  }, [modalMsg]);

  useDidMountEffect(() => {
    if (swapMupToAmoPending) {
      setOpenLoading(true);
    } else setOpenLoading(false);
  }, [swapMupToAmoPending]);

  useDidMountEffect(() => {
    if (swapMupToAmoSuccess) {
      stopInterval();

      //swapMupToAmoResultCode 값이 들어오면 실패
      if (swapMupToAmoResultCode) {
        dispatch(
          amoActions.showMsg({
            msg: `교환에 실패하였습니다.`,
            type: "",
          })
        );
      } else {
        navigate("/amo/change/result", { state: { type: "toAmo" } });
      }
    }
  }, [swapMupToAmoSuccess]);
  return (
    <Section className="nonePaddingTop">
      {openLoading && <Loading></Loading>}
      {openModal && (
        <Modal
          setOpenModal={setOpenModal}
          callbackFunc={() => {
            setPoint("");

            return;
          }}
        >
          <p>{modalMsg.type === "func" ? modalMsg.msg() : modalMsg.msg}</p>
        </Modal>
      )}
      <div>
        {isLogin && <TopPointBanner />}
        <Content>
          <SwapWrap>
            <div>
              <Title>
                <h4>뮤 포인트</h4>
                <button
                  onClick={() => {
                    setPoint(getMaxValue(swapInfo.info.mup));
                  }}
                >
                  최대
                </button>
              </Title>
              <InputWrap>
                <input
                  value={inputPriceFormat(point)}
                  // value={point}
                  type="text"
                  onChange={(e) => {
                    setPoint(e.target.value);
                  }}
                />
                <p>MUP</p>
              </InputWrap>

              {swapInfo.info &&
                (point > swapInfo.info.mup ? (
                  <Desc className="red">
                    {replaceCommas(swapInfo.info.mup)} MUP 초과하여 입력할 수
                    없습니다.
                  </Desc>
                ) : (
                  <Desc>{swapInfo.info.mupMin} MUP 이상 교환 가능합니다.</Desc>
                ))}
            </div>
            <div className="amo">
              <Title>
                <h4>교환될 AMO 코인</h4>
              </Title>
              {swapInfo.info && (
                <InputWrap>
                  <input value={getExchangeValue(point)} disabled />
                  <p>AMO</p>
                  {/*  */}
                </InputWrap>
              )}
            </div>
          </SwapWrap>
          {swapInfo.info && (
            <SwapContent>
              <h4>
                총 보유 {replaceCommas(swapInfo.info.mup)} MUP 중<br />{" "}
                {replaceCommas(point)} MUP를 AMO 코인으로 교환합니다.
              </h4>
              <ul>
                <li>
                  <div>· 일한도</div>
                  <div>=</div>
                  <div>{replaceCommas(swapInfo.info.mupMax)} MUP</div>
                </li>
                <li>
                  <div>· 월한도</div>
                  <div>=</div>
                  <div>{replaceCommas(swapInfo.info.mupMonthMax)} MUP</div>
                </li>
                <li>
                  <div>· 교환수수료</div>
                  <div>=</div>
                  <div>{swapInfo.info.mup2amoFee}% (뮤 포인트 차감)</div>
                </li>
              </ul>
              <p>
                AMO 코인은 디지털 자산으로서 취득 후 거래소의 시세에 따라 가치의
                변동이 있을 수 있습니다. (1분당 한번씩 갱신)
              </p>
            </SwapContent>
          )}
        </Content>
      </div>
      <Btns>
        <ButtonL onClick={checkingValue}>교환하기</ButtonL>
      </Btns>
    </Section>
  );
};

export default ToAmoComponent;
const SwapWrap = styled.div`
  padding-top: 1rem;
  & > div {
    margin-top: 3rem;
  }
`;
const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  h4 {
    font-weight: 700;
    line-height: 1.6rem; /* 100% */
  }
  button {
    width: 4rem;
    height: 2rem;
    flex-shrink: 0;
    border-radius: 1rem;
    background-color: ${({ theme }) => theme.color.purple_secondary};
    color: ${({ theme }) => theme.color.white};
    font-size: 1.2rem;
    line-height: 1.2rem; /* 100% */
  }
`;
const Desc = styled.p`
  font-weight: 700;
  font-size: 1.2rem;
  line-height: 1.2rem; /* 100% */
  color: ${({ theme }) => theme.color.purple_secondary};
  margin-top: 1rem;
  & .red {
    color: ${({ theme }) => theme.color.pink};
  }
`;
const InputWrap = styled.div`
  border-bottom: 1px solid #000;
  display: flex;
  justify-content: space-between;
  padding: 1rem 0;
  margin-top: 0.5rem;
  input {
    width: calc(100% - 5rem);
    color: ${({ theme }) => theme.color.black};
    font-size: 1.6rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.6rem; /* 100% */
    &:focus {
      outline: none;
    }
    background-color: transparent;
  }
  p {
    text-align: right;
    color: ${({ theme }) => theme.color.input_text_gray};
    font-weight: 400;
  }
`;
const SwapContent = styled.div`
  margin-top: 5.5rem;
  h4 {
    font-size: 1.4rem;
    line-height: 2rem; /* 142.857% */
    font-weight: 700;
  }
  ul {
    margin-top: 1rem;
    li {
      display: flex;
      align-items: center;
      color: ${({ theme }) => theme.color.purple_dark};
      font-size: 1.2rem;
      line-height: 1.8rem; /* 150% */
      font-weight: 500;
      div {
        &:nth-of-type(1) {
          min-width: 10rem;
        }
        &:nth-of-type(2) {
          margin-right: 3rem;
        }
      }
    }
  }
  p {
    margin-top: 1rem;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px; /* 150% */
    color: ${({ theme }) => theme.color.black};
  }
`;
